import { observer } from "mobx-react-lite";
import { ContextProps } from "@menu/core/types";
import { AnalyticsType, getAnalyticTags, gotoUrl } from "@menu/core/lib";

const CartIcon = observer((props: ContextProps) => {
  const { cart } = props.context;
  const { display, url, cartItems } = cart;

  if (!display) {
    return null;
  }

  const analyticTags = () => {
    const item = AnalyticsType.menu;
    const name = `header_cart_icon`;
    const text = "cart-icon";

    return getAnalyticTags({
        component_name: name,
        nav_item: item,
        nav_text: text,
        target_page_url: url
    });
}

  return (
    <span className="inbox-icon">
      <i className="icon-supermarket_32x32" {...analyticTags()} onClick={() => gotoUrl(url)} />
      {cartItems > 0 && <i className="unread-count">{cartItems}</i>}
    </span>
  );
});

export default CartIcon;
